import membershipPrivileges from 'helpers/membership_privileges';

angular.module('filters').filter('membershipPrivileges', function() {
  return function(membership) {
    return membershipPrivileges(membership);
  };
});
